module.exports = __webpack_public_path__ + "static/media/mobileApp.1eebeb7b.svg";